import { render } from "./PaintingsGallery.vue?vue&type=template&id=7959be40"
import script from "./PaintingsGallery.vue?vue&type=script&lang=js"
export * from "./PaintingsGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__